import { reactive } from 'vue';

const STORAGE_KEY = 'abol.sidenav.collapsed';
const HTML_CLASS = 'sidenav-collapsed';

const read = (): boolean => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const write = (value: boolean): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
  } catch {
    /* storage unavailable */
  }
};

/** Shared sidebar state; the layout widths are driven by a class on <html>. */
export const sidenavState = reactive({ collapsed: read() });

const apply = (): void => {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle(HTML_CLASS, sidenavState.collapsed);
};

export const setSidenavCollapsed = (value: boolean): void => {
  sidenavState.collapsed = value;
  write(value);
  apply();
  // charts and other width-aware widgets only listen to window resize
  window.setTimeout(() => window.dispatchEvent(new Event('resize')), 240);
};

export const toggleSidenav = (): void => setSidenavCollapsed(!sidenavState.collapsed);

apply();
